import {GridLazy} from 'app/components/multimedia/gallery/grid/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

import {shouldSkipLazyLoad} from './shouldSkipLazyLoad';

export function defineMultimediaGrid(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-multimedia-grid')) {
        return;
    }

    customElements.define(
        'gem-multimedia-grid',
        class extends WebComponentLoader {
            reactLazyComponent = GridLazy;
            shouldSkipLazyLoad = shouldSkipLazyLoad;
        },
    );
}
